export default (props) => {
	const { size = 'md' } = props;
	if (size === 'lg') {
		return `padding: .5rem 1rem;
        font-size: 1.25rem;
        line-height: 1.5;
        border-radius: .3rem;`;
	}
	if (size === 'sm') {
		return `padding: .25rem .5rem;
        font-size: .875rem;
        line-height: 1.5;
        border-radius: .2rem;`;
	}
	return `padding: .375rem .75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: .25rem;`;
};
